module.exports = __webpack_public_path__ + "static/media/logo-sanpaolo-branco.80b4a75f.png";